import FormInputRadioCheckbox from 'components/FormAddTransaction/components/FormInputRadioCheckbox';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import useLang from 'hooks/useLang';
import React from 'react';
import styled from 'styled-components';
import {
  cursorPointerMixin,
  displayFlexColStartCenterMixin,
  paragraph500Mixin,
} from 'styles';

/* MOCK DATA */
// {
//   "senderBankId": "V2L7QEMD2RDEGX59",
//   "bankName": "HPC Cuscal Limited",
//   "bankCode": "CRU",
//   "holder": "MR PAUL CLEMENS",
//   "bsb": "802950",
//   "accountNumber": "*********100"
// }

const AccountNumberVerifiedItem = ({ data = {}, onSelect = () => {} }) => {
  const { t } = useLang();
  const { paytoAccountInformation } = usePaytoStore();

  const { bankName, bsb, accountNumber, senderBankId } = data || {};
  const { id } = paytoAccountInformation || {};
  const isSelected = id === senderBankId;
  const isOtherSelected = senderBankId === 'other';
  const isPayidSelected = senderBankId === 'payid';

  const handleOnClick = () => {
    if (isOtherSelected && id === 'other') return;
    if (isPayidSelected && id === 'payid') return;
    onSelect(data);
  };

  const renderDetailsSection = () => {
    if (isOtherSelected) {
      return (
        <AccountNumber>{`${t('label_use_other_payto_account')}`}</AccountNumber>
      );
    }
    if (isPayidSelected) {
      return <AccountNumber>{`${t('label_using_payid')}`}</AccountNumber>;
    }
    return (
      <DetailsSection>
        <AccountNumber>{`${t(
          'label_bank_account_number'
        )}: ${accountNumber}`}</AccountNumber>
        <BSBNumber>{`(${bsb}) ${bankName || ''}`}</BSBNumber>
      </DetailsSection>
    );
  };

  return (
    <AccountNumberVerifiedItemStyled onClick={handleOnClick}>
      <FormInputRadioCheckbox
        isChecked={isSelected}
        styles={{ marginBottom: 0 }}
      />
      <DetailsSection>{renderDetailsSection()}</DetailsSection>
    </AccountNumberVerifiedItemStyled>
  );
};

const AccountNumberVerifiedItemStyled = styled.div`
  display: grid;
  grid-template-columns: 24px 100%;
  align-content: start;
  ${cursorPointerMixin};
`;

const DetailsSection = styled.div`
  ${displayFlexColStartCenterMixin};
  width: calc(100% - 24px);
`;

const AccountNumber = styled.p`
  ${paragraph500Mixin};
`;
const BSBNumber = styled.p`
  ${paragraph500Mixin};
  font-size: 14px;
  color: var(--ds-c-grey-neutral);
`;

export default AccountNumberVerifiedItem;
